import * as actionTypes from '../types/qr';

export function qrData(payload) {
  return {
    type: actionTypes.QR_DATA,
    payload
  };
}

export function qrDataSuccess(payload) {
  return {
    type: actionTypes.QR_DATA_SUCCESS,
    payload
  };
}

export function qrDataFail(payload) {
  return {
    type: actionTypes.QR_DATA_FAIL,
    payload
  };
}

export function qrDataList(payload) {
  return {
    type: actionTypes.QR_DATA_LIST,
    payload
  };
}

export function qrDataListSuccess(payload) {
  return {
    type: actionTypes.QR_DATA_LIST_SUCCESS,
    payload
  };
}

export function qrDataListFail(payload) {
  return {
    type: actionTypes.QR_DATA_LIST_FAIL,
    payload
  };
}

export function qrDataUpdateStorage(payload) {
  return {
    type: actionTypes.QR_DATA_UPDATE_STORAGE,
    payload
  };
}

export function qrDataClear(payload) {
  return {
    type: actionTypes.QR_DATA_CLEAR,
    payload
  };
}

export function deletingPiece(payload) {
  return {
    type: actionTypes.DELETING_PIECE,
    payload
  };
}

export function deletingPieceSuccess(payload) {
  return {
    type: actionTypes.DELETING_PIECE_SUCCESS,
    payload
  };
}

export function deletingPieceFail(payload) {
  return {
    type: actionTypes.DELETING_PIECE_FAIL,
    payload
  };
}
